import Show from '../show'

function UbFixedUsageDashboard() {
  return (
    <Show
      title="Utility Billing — Fixed Usage Dashboard"
      dashboardKey="ub_fixed_usage_dashboards"
      showYear={false}
    />
  )
}

export default UbFixedUsageDashboard
